import { IncomingRegisterRequest } from "../messages/methods/register";
import { IncomingRequestDelegate } from "../messages/incoming-request";
import { IncomingRequestMessage } from "../messages/incoming-request-message";
import { NonInviteServerTransaction } from "../transactions/non-invite-server-transaction";
import { UserAgentCore } from "../user-agent-core/user-agent-core";
import { UserAgentServer } from "./user-agent-server";

/**
 * REGISTER UAS.
 * @public
 */
export class RegisterUserAgentServer extends UserAgentServer implements IncomingRegisterRequest {
  constructor(protected core: UserAgentCore, message: IncomingRequestMessage, delegate?: IncomingRequestDelegate) {
    super(NonInviteServerTransaction, core, message, delegate);
  }
}
